import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { decode } from 'shopify-gid'
import { LayoutContext } from '../../contexts'
import { desktopVW, mobileVW } from '../../styles'
import useShopifyProduct from '../../hooks/useShopifyProduct'
import useReplaceLineItem from '../../hooks/useReplaceLineItem'
import { useProductAddedTracking } from '../../hooks/tracking'
import { Icon } from '../shared/Icon'
import { useGlobal } from '../../hooks/useGlobal'

const GiftWrapping = ({ checkoutId, cartUnitCount }) => {
  const { currency, node_locale } = useContext(LayoutContext)

  const {
    layout: { cartGiftWrappingText, giftWrappingProduct },
  } = useGlobal(['layout'], node_locale)

  const { product } = useShopifyProduct(giftWrappingProduct.handle)
  const [replaceLineItem, _] = useReplaceLineItem()

  const addToCart = async (variantId, quantity) => {
    await replaceLineItem({
      variantId: variantId,
      quantity: quantity,
    })

    useProductAddedTracking({
      currency: currency?.code,
      locale: node_locale,
      checkoutId: checkoutId,
      productId: product && decode(product.variants.edges[0].node.id).id,
      sku: product?.variants.edges[0].node.sku,
      name: product?.title,
      variant: 'OS',
      price: 0,
      quantity: 1,
      value: 0,
      viewType: 'Cart',
      sectionType: 'Cart',
    })
  }

  return (
    <>
      <StyledGiftWrapping
        onClick={() =>
          addToCart(product?.variants.edges[0].node.id, cartUnitCount)
        }
      >
        <StyledButton>
          <GiftIcon name='gift-wrapping' />
          <Text>{cartGiftWrappingText}</Text>
        </StyledButton>
      </StyledGiftWrapping>
    </>
  )
}
const Text = styled.span`
  max-width: 60%;
  line-height: 1.2;
`

const StyledGiftWrapping = styled.button`
  cursor: pointer;
  width: 100%;
  background: #fff;
  border: 1px solid ${(props) => props.theme.colors.mediumGrey};
  font-size: ${(props) => props.theme.fontSize.m23};
  letter-spacing: 0.05em;
  padding: ${(props) => props.theme.space.marginMobile}vw 0;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
    padding: ${(props) => props.theme.space.marginDesktop * 2}vw 0;

    &:hover {
      border-color: ${(props) => props.theme.colors.blue};
    }
  }
`

const StyledButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: inherit;
  margin: 0 auto;

  span {
    margin-left: ${mobileVW(8)};

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      margin-left: ${desktopVW(15)};
    }
  }
`

const GiftIcon = styled(Icon)`
  position: relative;
  width: ${mobileVW(13)};
  top: ${mobileVW(-1)};

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    top: ${desktopVW(-3)};
    width: ${desktopVW(24)};
  }
`

export default GiftWrapping
